import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { changePassword } from '../../../redux/modules/auth'
import { reduxForm, change } from 'redux-form'
import FormTextField from '../../../components/FormTextField'
import LanguageSelectorV2 from '../../../components/LanguageSelectorV2'
import { deletePatientAccount, fetchLanguages, getPatient, hideModal, setPatientLanguageById, startSaving } from '../../../redux/actions'
import { isSavingSelector, languagesSelector, patientSelector } from '../../../redux/selectors'
import { required, passwordStrength, passwordMatch } from '../../../utilties/validators'
import Button from '@material-ui/core/Button'
import { useTheme, withStyles } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import * as cookies from '../../../utilties/cookies'

const styles = {
  input: {
    color: 'white',
    fontSize: '1.7rem'
  },

}

const useStyles = makeStyles((theme) => ({
  gridStyle: {
    padding: '4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '3rem 2rem',
    }
  },
  formStyle: {
    width: 'calc(300px + 4rem)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(300px + 4rem)',
      width: '100%',
    }
  },
  inputLabel: {
    fontSize: '1.7rem'
  },
  deleteButton: {
    backgroundColor: 'red'
  }
}))

const RequestAccountDeletion = ({ intl, deleteAccount, closeModal, isSaving, startSaving }) => {
  const [patientCookie] = useState(cookies.get('user'))

  const classes = useStyles()

  const deleteClickHandler = () => {
    startSaving()
    deleteAccount(patientCookie.id);
  }

  return (
    <div className={classes.formStyle}>
      <Grid container direction="column" className={classes.gridStyle}>
        <Grid item style={{ paddingBottom: '20px', textAlign: 'center', textTransform: 'uppercase' }}>
          <Typography
            variant="h3"
            data-testid="delete-account-title">{intl.formatMessage({ id: 'app.accountDeletion.modalHeader' })}</Typography>
        </Grid>

        <Grid item style={{ paddingBottom: '20px', textAlign: 'center', color: 'red' }}>
          <Typography
            variant="body1"
            data-testid="delete-account-text">{intl.formatMessage({ id: 'app.accountDeletion.modalText' })}</Typography>
        </Grid>

        <Grid item style={{ paddingBottom: '20px', textAlign: 'center', color: 'red' }}>
          <Typography
            variant="body1"
            data-testid="delete-account-confirmation">{intl.formatMessage({ id: 'app.accountDeletion.modalConfirmationText' })}</Typography>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={2}
          justifyContent="center"
        >
          <Grid item style={{ textAlign: 'center' }}>
            <Button
              data-testid="change-password-button-submit"
              variant='contained'
              className={classes.deleteButton}
              onClick={deleteClickHandler}
              disabled={isSaving}>
              {intl.formatMessage({ id: 'app.accountDeletion.deleteButtonLabel' })}
            </Button>
          </Grid>
          <Grid item style={{ textAlign: 'center' }}>
            <Button
              data-testid="change-password-button-submit"
              variant='outlined'
              color='secondary'
              onClick={closeModal}>
              {intl.formatMessage({ id: 'app.cancelButton' })}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  isSaving: isSavingSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  deleteAccount: (patientId) => dispatch(deletePatientAccount(patientId)),
  closeModal: () => dispatch(hideModal()),
  startSaving: ()=> dispatch(startSaving())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl, withStyles(styles))

export default enhance(RequestAccountDeletion)
